<div class="pdf-wrapper">
  <div class="pdf-content">
    <span class="name">{{ pdfInfo.name }}</span>
    <app-button text="Télécharger le document" (click)="downloadPdf()" icon="document" size="lg"></app-button>
  </div>
  <app-button *ngIf="!isBackOffice && mcq?.length <= 0" class="next-course-button" [text]="isSelectedCourseLast ? 'Compléter le module' : 'Cours suivant'" (onClick)="goToNextCourse.emit()"></app-button>
</div>
